import { concatClasses } from "../../../helpers/concatClasses/index.js";
const getDividerClasses = ({ dsf_size }) => {
  const classes = ["flex flex-auto items-center justify-center rounded-full bg-neutral-100"];
  classes.push(dsf_size === "small" ? "h-12 w-12" : "h-14 w-14");
  return concatClasses(classes);
};
const getArrowClasses = ({ dsf_size }) => {
  const classes = [];
  classes.push(dsf_size === "small" ? "h-12 w-12" : "h-14 w-14");
  return concatClasses(classes);
};
export {
  getArrowClasses,
  getDividerClasses
};
